import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { url } from "../../data/url";
import axios from "axios";
import {
  FaLinkedin,
  FaBookmark,
  FaRegBookmark,
  FaSearch,
  FaBuilding,
} from "react-icons/fa";

const backgroundColors = ["#fff5e6", "#e3f0f7", "#f0e6ff"];

const JobCard = ({ company, index, toggleBookmark }) => {
  const navigate = useNavigate();
  const handlePreviewJob = (company) => {
    navigate(`/user/internship/${company.id}/description`);
  };
  return (
    <div className="job-card">
      <div
        className="job-detail"
        style={{
          backgroundColor: backgroundColors[index % backgroundColors.length],
        }}
      >
        <div className="job-card-header">
          <div className="job-card-header-container">
            <a className="company-links"
              href={company.employerPage}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="company-info">
                {company.companyLogo && <img
                  src={company.companyLogo}
                  alt={company.companyName}
                  className="company-logo"
                />}
                <span className="company-name">{company.companyName}</span>
              </div>
            </a>
          </div>
          {company.isSaved === "yes" ? (
            <FaBookmark className="bookmark-icon" onClick={() => toggleBookmark(company.id)} />
          ) : (
            <FaRegBookmark className="bookmark-icon" onClick={() => toggleBookmark(company.id)} />
          )}
        </div>
        <div className="job-info-container">
          <div className="job-title">
            <h2>{company.jobTitle}</h2>
          </div>
          <div className="job-other-details">
            <div className="job-other-details-container">
              <div className="lcn-mode">
                <div>{company.mode}</div>
                <div className="company-lcn">{company.location}</div>
              </div>
              <div className="job-salary">
                <span>{company.salary}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="job-card-footer">
        <button className="view-button" onClick={() => handlePreviewJob(company)}>View</button>
        <div className="company-links">
          {company.linkedIn && <a 
            href={company.linkedIn} 
            target="_blank" 
            rel="noopener noreferrer">
            <FaLinkedin className="company-link-icon" />
          </a>}
          {company.glassdoorLink && <a
            href={company.glassdoorLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaBuilding className="company-link-icon" />
          </a>}
        </div>
      </div>
    </div>
  );
};

const JobBoard = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [companies, setCompanies] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [activeNavItem, setActiveNavItem] = useState("All");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  
  axios.defaults.withCredentials = true;

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    setIsLoading(true);
    setError(null);
    try {

      const response = await axios.get(`${url.path}/user/internship-board`);
      setCompanies(response.data);
      setFilteredCompanies(response.data);
    } catch (err) {

      if(err.response && err.response.status === 401) {
        navigate('/signin');
      }
      setError("Failed to fetch jobs. Please try again later.");
      console.error("Error fetching jobs:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const results = companies.filter(
      (company) =>
        company.jobTitle.toLowerCase().includes(searchTerm.toLowerCase()) ||
        company.companyName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredCompanies(results);
  }, [searchTerm, companies]);

  useEffect(() => {
    if (activeNavItem === "All") {
      setFilteredCompanies(companies);
    } else {
      setFilteredCompanies(
        companies.filter((company) => company.isSaved === "yes")
      );
    }
  }, [activeNavItem, companies]);

  const toggleBookmark = async (id) => {
    try {
      await axios.post(`${url.path}/user/save-job/${id}`);
      const updatedCompanies = companies.map(company => {
        if (company.id === id) {
          return {...company, isSaved: company.isSaved === "yes" ? "no" : "yes"};
        }
        return company;
      });
      setCompanies(updatedCompanies);
      setFilteredCompanies(activeNavItem === "All" ? updatedCompanies : updatedCompanies.filter(company => company.isSaved === "yes"));
    } catch (err) {
      console.error("Error toggling bookmark:", err);
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="postings-container">
    <div className="postings">
      <div className="postings-header">
        <div className="postings-card-info">
          <div className="postings-top-header">
            <div>
              <h1>{`Internship${filteredCompanies.length > 1 ? 's' : ''}`}</h1>
            </div>
            <div className="search-container">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search jobs..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
          </div>
          <p>
            Congratulations, it's time to apply for internships and  connect with employers who are eager
            to find talent like yours.
          </p>
        </div>
      </div>
      <div className="postings-main-container">
          <nav className="modern-nav">
            <ul>
              {["All", "Saved"].map((item) => (
                <li
                  key={item}
                  className={activeNavItem === item ? "active" : ""}
                  onClick={() => setActiveNavItem(item)}
                >
                  {item}
                </li>
              ))}
            </ul>
          </nav>
          {filteredCompanies.length > 0 ? (<div className="job-board">
            {filteredCompanies.map((company, index) => (
              <JobCard
                key={company.id}
                company={company}
                index={index}
                toggleBookmark={toggleBookmark}
              />
            ))}
          </div>) : <div className="jobBoard-placeholder">
              No internship posted yet
            </div>}
        </div>
      </div>
    </div>
  );
};

export default JobBoard;